/* eslint-disable no-lone-blocks */
import React, {useEffect, useState} from "react";
import ReactRecaptcha3 from "react-google-recaptcha3";
import {SITE_KEY} from "../utilities";
import {BRANDINGS_ICONS} from "../const/brandings";
import { useNavigate, useLocation } from "react-router-dom";
import { Switch } from "antd";

export const LoginPage = ({ login }) => {
  console.log("v1")
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEurope = queryParams.get('region')?.toUpperCase() === 'EU';

  useEffect(() => {
    ReactRecaptcha3.init(SITE_KEY).then((status) => {
      //console.log(status);
    });
  }, []);


  const handleLogin = () => {
    ReactRecaptcha3.getToken().then(
        (token) => {
          if (login) {
            login();
          } else {
            console.error("La función de login no se ha proporcionado.");
          }
        },
        (error) => {
          console.log("Recaptcha error:", error);
          if (login) {
            login();
          }
        }
    );
  };

  return (
    <>
        <div className="App-body-login">
              <div className="login-content">
                <div className="login-form">
                  <img className="login-logo" src={BRANDINGS_ICONS.woeLogo} alt="WOE Logo" />

                  <p className="login-title">¡Te damos la bienvenida!</p>

                  <button className="App-login-button" onClick={handleLogin}>
                    Ingresar
                  </button>

                  <a
                    className="avisoprivacidad"
                    href={`/Politicas_de_privacidad`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Aviso de privacidad
                  </a>
                </div>
              </div>

              <footer className="login-footer">
                <div className="footer-brands">
                  <img src={BRANDINGS_ICONS.allBrands} alt="Marcas" className="brands-logo" />
                </div>

                <div className="footer-separator" />

                <img src={BRANDINGS_ICONS.alseaLogo} alt="Alsea" className="alsea-logo" />
              </footer>
            </div>
    </>
  );
};
